import(/* webpackMode: "eager" */ "/vercel/path0/components/ScrapbookPhotos.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js")